var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_c('router-link',{attrs:{"to":"/me"}},[_vm._v("Me")]),_c('router-link',{attrs:{"to":"/projects"}},[_vm._v("Projects")]),_c('router-link',{attrs:{"to":"/get-in-touch"}},[_vm._v("Get in touch")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }